"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/lib/utils";
import { toggleVariants } from "@/shared/components/ui/toggle";
const ToggleGroupContext = React.createContext<VariantProps<typeof toggleVariants>>({
  size: "default",
  variant: "default"
});
function ToggleGroup(t0) {
  const $ = _c(20);
  let children;
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== size || $[9] !== variant) {
    t2 = {
      variant,
      size
    };
    $[8] = size;
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== t2) {
    t3 = <ToggleGroupContext.Provider value={t2}>{children}</ToggleGroupContext.Provider>;
    $[11] = children;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== props || $[15] !== size || $[16] !== t1 || $[17] !== t3 || $[18] !== variant) {
    t4 = <ToggleGroupPrimitive.Root data-slot="toggle-group" data-variant={variant} data-size={size} className={t1} {...props}>{t3}</ToggleGroupPrimitive.Root>;
    $[14] = props;
    $[15] = size;
    $[16] = t1;
    $[17] = t3;
    $[18] = variant;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function ToggleGroupItem(t0) {
  const $ = _c(18);
  let children;
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      children,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    variant = $[5];
  }
  const context = React.useContext(ToggleGroupContext);
  const t1 = context.variant || variant;
  const t2 = context.size || size;
  let t3;
  if ($[6] !== className || $[7] !== context.size || $[8] !== context.variant || $[9] !== size || $[10] !== variant) {
    t3 = cn(toggleVariants({
      variant: context.variant || variant,
      size: context.size || size
    }), "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l", className);
    $[6] = className;
    $[7] = context.size;
    $[8] = context.variant;
    $[9] = size;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t4 = <ToggleGroupPrimitive.Item data-slot="toggle-group-item" data-variant={t1} data-size={t2} className={t3} {...props}>{children}</ToggleGroupPrimitive.Item>;
    $[12] = children;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export { ToggleGroup, ToggleGroupItem };